import type { FaireProductEntity } from "../../entity_types/product";

export const p_gwn9m4m2bk: FaireProductEntity = {
  token: "p_gwn9m4m2bk",
  type: "product",
  name: "Patchwork Pants (TH-1692)",
  brandToken: "b_a990dearj1",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/597a5c67f904b1a8b19d56e55079faa2c214010bea82fb4acd9a2d0e7ce71ba9.jpeg",
  galleryImageUrls: [],
  priceDollars: 36.03,
  description:
    "Patchwork pants with elastic ankles, pockets, and drawstrings\nFree Size",
  tags: [],
  msrpDollars: 72.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:45.964Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
